import { FormGroup, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { GlobalService } from './global.service';
// import { FormGroup, ValidatorFn, AbstractControl } from '@angular/forms';
// import { GlobalClass } from '../_services/global';
import * as moment from 'moment';

export class CustomValidator {

  static YearValidation(AC: AbstractControl) {

    const startyear = AC.get('startyear').value;
    const endyear = AC.get('endyear').value;
    if (startyear != null && endyear != null && startyear != '' && endyear != '') {
      if (startyear > endyear) {
        AC.get('endyear').setErrors({ YearValidation: true });
      } else {
        return null;
      }
    }else {
      return null
    }


  }
  static DateValidation(AC: AbstractControl) {
    const startdateyear = AC.get('startdate').value.year
    const startdatemonth = AC.get('startdate').value.month
    const enddateyear = AC.get('enddate').value.year
    const enddatemonth = AC.get('enddate').value.month
    if (startdateyear != null && startdatemonth != null && enddatemonth != null && enddateyear != null) {
      const startdate = GlobalService.dateFormat('01', startdatemonth, startdateyear)
      const enddate = GlobalService.dateFormat('01', enddatemonth, enddateyear)
      if (enddatemonth !== '' && enddateyear !== '') {
        if (new Date(startdate) > new Date(enddate)) {
          AC.get('enddate').setErrors({ DateValidation: true });
        } else {
          AC.get('enddate').setErrors(null);        }
      } else {
        AC.get('enddate').setErrors(null);
      }
    }
  }

  static ExperienceValidation (AC: AbstractControl) {
    const totalexperienceyear = AC.get('totalexperienceyear').value
    const totalexperiencemonth = AC.get('totalexperiencemonth').value
    if (totalexperienceyear === '0' && totalexperiencemonth === '0') {
      AC.get('totalexperienceyear').setErrors({ ExperienceValidation: true });
      AC.get('totalexperiencemonth').setErrors({ ExperienceValidation: true });
    } else {
      AC.get('totalexperienceyear').setErrors(null);
      AC.get('totalexperiencemonth').setErrors(null);
    }
  }

  static GreaterThan(AC: AbstractControl) {
    const start = AC.get('salarystartrange').value;
    const end = AC.get('salaryendrange').value;
    if(start !== null && end !== null && start >= end){
      AC.get('salaryendrange').setErrors({ incorrectSalaryRange:true})
    }else{
     return null
    }
  };

  static MatchPassword(AC: AbstractControl) {
    const password = AC.get('password').value; // to get value in input tag
    const confirmPassword = AC.get('confirmpassword').value; // to get value in input tag
    if (password !== confirmPassword) {
        AC.get('confirmpassword').setErrors({ MatchPassword: true });
    } else {
      AC.get('confirmpassword').setErrors(null);

    }
}
static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (!control.value) {
      // if control is empty return no error
      return null;
    }

    // test the value of the control against the regexp supplied
    const valid = regex.test(control.value);

    // if true, return no error (no error), else return error passed in the second parameter
    return valid ? null : error;
  };
}

static keywordIncludes(keywordCheck: string, error: ValidationErrors): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }
      // check if control value contains the specified keyword
      const invalid = control.value.toLowerCase().includes(keywordCheck);
  
      // if true, return no error (no error), else return error passed in the second parameter
      return invalid ? error : null;
    };
  }



// validation : All salary fields should be empty or all should be filled
 static CurrencySalaryValidator(control:AbstractControl):{ [key:string]:boolean}|null{
  const currency = control.get('currency').value;
  const salarystartrange =control.get('salarystartrange').value;
  const salaryendrange =control.get('salaryendrange').value;
  if(currency && salarystartrange && salaryendrange){
    control.get('salarystartrange').setErrors(null)
    control.get('salaryendrange').setErrors(null)
    control.get('currency').setErrors(null)
    return  null;
  }else if((currency==null || currency=='')  && (salarystartrange==null || salarystartrange=='') && (salaryendrange==null || salaryendrange=='')){
    control.get('salarystartrange').setErrors(null)
    control.get('salaryendrange').setErrors(null)
    control.get('currency').setErrors(null)
    return  null;
  }else{
    if(currency){
      control.get('currency').setErrors(null)
      if(!salarystartrange){
        control.get('salarystartrange').setErrors({ required: true })
      }
       if(!salaryendrange){
        control.get('salaryendrange').setErrors({ required: true })
      }
    }
    if(salarystartrange){
      control.get('salaryendrange').setErrors(null)
      if(!currency){
        control.get('currency').setErrors({ required: true })     
      } 
      if(!salaryendrange){
        control.get('salaryendrange').setErrors({ required: true })
      }
    }
    if(salaryendrange){
      if(!currency){
        control.get('currency').setErrors({ required: true })    
      }
       if(!salarystartrange){
        control.get('salarystartrange').setErrors({ required: true })    
      }
    }
  }
}

static extractRootDomain(url: string): string {
  let domain = this.extractHostname(url);
  const splitArr = domain.split('.');
  const arrLen = splitArr.length;

  // get root domain
  if (arrLen > 2) {
      domain = splitArr[arrLen - 2] + '.' + splitArr[arrLen - 1];
      // see if it's using a Country Code Top Level Domain (ccTLD) (i.e. ".me.uk")
      if (splitArr[arrLen - 2].length === 2 && splitArr[arrLen - 1].length === 2) {
          domain = splitArr[arrLen - 3] + '.' + domain;
      }
  }

  return domain;
}

static extractHostname(url: string): string {
  let hostname;

  // remove protocol
  if (url.indexOf('//') > -1) {
      hostname = url.split('/')[2];
  } else {
      hostname = url.split('/')[0];
  }

  // remove port
  hostname = hostname.split(':')[0];

  // remove query
  hostname = hostname.split('?')[0];

  return hostname;
}


}
